// Copy for every confirmation in the module. Only actions with consequences the
// admin may not expect (lost edits, replaced content, real customer delivery)
// ask for confirmation; routine saves and tests do not.
export const getConfirmation = (action, context = {}) => {
  switch (action) {
    case "selectScenario":
      return {
        title: `Use “${context.title}” for campaign ${context.slot}?`,
        description: [
          `Reserves the audience for campaign ${context.slot}`,
          "Builds it in the background",
          "No messages are sent",
          context.slot === "B" && "Customers already reserved for campaign A are excluded"
        ].filter(Boolean),
        confirmLabel: "Use scenario"
      };
    case "generate":
      return {
        title: context.hasContent ? "Replace content with a new AI version?" : "Generate content and banners?",
        description: context.hasContent
          ? ["AI rewrites all four send-day messages and email banners", "Current saved content is replaced", "Fresh internal tests can be sent"]
          : ["AI writes all four send-day messages for the weekly channel plan", "Plus one email banner per send day", "Final review and internal testing stay available"],
        confirmLabel: context.hasContent ? "Replace content" : "Generate",
        destructive: !!context.hasContent
      };
    case "discardEdits":
      return {
        title: "Discard unsaved edits?",
        description: ["The latest saved content is reloaded", "Your unsaved changes are lost"],
        confirmLabel: "Discard edits",
        destructive: true
      };
    case "leave":
      return {
        title: "Leave with unsaved edits?",
        description: ["Your local edits will be lost", "Saved campaign content is unchanged"],
        confirmLabel: "Leave",
        cancelLabel: "Keep editing",
        destructive: true
      };
    case "activate":
      return {
        title: "Start customer delivery?",
        description: [
          `Revision ${context.revision} is scheduled for ${Number(context.audienceCount || 0).toLocaleString()} customers`,
          "Covers all four weekly send-day messages",
          "Real messages are sent on the scheduled days"
        ],
        confirmLabel: "Start delivery",
        destructive: true
      };
    case "pause":
      return {
        title: "Pause this campaign?",
        description: [
          "Scheduled messages stop",
          "A provider request already in flight may still finish",
          "Windows missed while paused are not sent later"
        ],
        confirmLabel: "Pause campaign",
        destructive: true
      };
    default:
      return null;
  }
};
